import type { PortalPromoDto } from '@supply-mover-2-0/shared';
import type { JSX } from 'react';
import { PromoTile } from './PromoTile';
import type { PromoClickTarget } from './promoClickTarget';

/**
 * Full-width hero banner. Renders the first selected promo at hero
 * size. Selection helper enforces limit=1 by default for this widget
 * type.
 */
export function PromoBannerWidget({
	promos,
	density,
	onSelect,
	onLikelyStaleUrl,
}: {
	promos: Array<PortalPromoDto>;
	density?: 'standard' | 'compact';
	/**
	 * Forwarded to each tile. Omit to render tiles inert (CRM
	 * designer preview). See `PromoTile.onSelect`.
	 */
	onSelect?: (target: PromoClickTarget) => void;
	/** Forwarded to each PromoTile. See `PromoTile.onLikelyStaleUrl`. */
	onLikelyStaleUrl?: () => void;
}): JSX.Element | null {
	const promo = promos[0];
	if (promo == null) return null;
	return (
		<div className="w-full h-full">
			<PromoTile
				promo={promo}
				size="hero"
				density={density}
				onSelect={onSelect}
				onLikelyStaleUrl={onLikelyStaleUrl}
			/>
		</div>
	);
}
